// @flow

import React from 'react';
import styled from 'styled-components';
import { Tooltip, Position, Icon } from '@blueprintjs/core';

type Props = {
  label: string,
  onClick: (e: SyntheticEvent<HTMLButtonElement>) => void,
  disabled?: boolean,
  tooltip?: string,
  size?: 'sm' | 'md',
};

const Pill = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: ${(p) => (p.size === 'sm' ? '2px 8px' : '4px 10px')};
  border-radius: 999px;
  border: 1px dashed #a7b6c2;
  background: transparent;
  color: ${(p) => (p.disabled ? '#a7b6c2' : '#5c7080')};
  font-size: ${(p) => (p.size === 'sm' ? '11px' : '12px')};
  cursor: ${(p) => (p.disabled ? 'not-allowed' : 'pointer')};
  white-space: nowrap;
  &:hover {
    color: ${(p) => (p.disabled ? '#a7b6c2' : '#182026')};
    border-color: ${(p) => (p.disabled ? '#a7b6c2' : '#5c7080')};
  }
  &:focus {
    outline: 1px solid #137cbd;
    outline-offset: 1px;
  }
`;

const AddPill = ({
  label,
  onClick,
  disabled,
  tooltip,
  size = 'md',
}: Props) => {
  const button = (
    <Pill
      type="button"
      size={size}
      disabled={disabled}
      onClick={(e) => {
        e.stopPropagation();
        if (!disabled) onClick(e);
      }}
      aria-label={label}
    >
      <Icon icon="plus" iconSize={size === 'sm' ? 10 : 12} />
      <span>{label}</span>
    </Pill>
  );

  if (tooltip) {
    return (
      <Tooltip content={tooltip} position={Position.TOP} disabled={!disabled && !tooltip}>
        {button}
      </Tooltip>
    );
  }
  return button;
};

export default AddPill;
